export const isBlockContainer = (blockType: string) => blockType in ['container', 'gridcard']
